import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { MessageBox } from 'element-ui'
import listData from '@/router/listData'


Vue.use(VueRouter)
//解决冗余导航
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/Login'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login'),
    mate: {
      title: '登录'
    }
  },
  {
    path: '/',
    name: 'login2',
    component: () => import('@/views/Login'),
    mate: {
      title: '登录'
    }
  },
  {
    path: '/text',
    name: 'text',
    component: () => import('@/views/Text')
  },
  {
    path: '/page',
    name: 'page',
    component: () => import('@/views/page'),
    children: listData
  },
  {
    path: '/examination',
    name: 'examination',
    component: () => import('@/views/Examination'),
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import('@/views/Recruitment'),
  },

]




const router = new VueRouter({
  routes
})


let bai = ['index', 'login2', 'text', 'recruitment'] // 白名单
router.beforeEach((to, from, next) => {
  if (bai.indexOf(to.name) !== -1) {
      next();
  } else {
    // 判断用户是否存在token如果有就自动登录，没有就跳登录界面
    if (localStorage.getItem('token')) {
      if (JSON.parse(localStorage.getItem('tokenInfo')).updatePwd == 'NO') {
        next();
      } else {
        if (to.name == 'password') {
          next();
        } else {
          next('/page/Password')
          MessageBox('当前密码不安全, 请立即修改密码后在进行其他操作!', '修改密码', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      }
    } else {
      next('/');
    }
  }
})

export default router
